import { apiFetch } from '@/lib/api';
import {
  type DemoActorEnroll,
  type DemoCaptchaChallenge,
  DemoCaptchaChallengeSchema,
  type DemoQrGalleryResponse,
  DemoQrGalleryResponseSchema,
  type DemoResetRequest,
  type DemoStatus,
  DemoStatusSchema,
} from '@tunodo/ticketing-shared';
import { z } from 'zod';

/**
 * Flag UI: espejo de DEMO_MODE_ENABLED del backend.
 * Vite reemplaza `import.meta.env.VITE_DEMO_MODE_ENABLED` en build time.
 */
export const isDemoModeEnabled = (): boolean => import.meta.env.VITE_DEMO_MODE_ENABLED === 'true';

const EnrollResponseSchema = z.object({
  attendeeId: z.string().uuid(),
  shortCode: z.string().length(6),
});
export type DemoEnrollResponse = z.infer<typeof EnrollResponseSchema>;

const ResetReportSchema = z
  .object({
    preset: z.string().optional(),
    eventId: z.string().optional(),
    counts: z.record(z.number()).optional(),
  })
  .passthrough();
export type DemoResetReport = z.infer<typeof ResetReportSchema>;

export function getDemoStatus(): Promise<DemoStatus> {
  return apiFetch<DemoStatus>('/api/demo/status', { schema: DemoStatusSchema });
}

export function getDemoCaptcha(): Promise<DemoCaptchaChallenge> {
  return apiFetch<DemoCaptchaChallenge>('/api/demo/captcha', {
    schema: DemoCaptchaChallengeSchema,
  });
}

export function enrollDemoActor(input: DemoActorEnroll): Promise<DemoEnrollResponse> {
  return apiFetch<DemoEnrollResponse>('/api/demo/enroll', {
    method: 'POST',
    body: JSON.stringify(input),
    schema: EnrollResponseSchema,
  });
}

export function resetDemo(input: DemoResetRequest): Promise<DemoResetReport> {
  return apiFetch<DemoResetReport>('/api/demo/reset', {
    method: 'POST',
    body: JSON.stringify(input),
    schema: ResetReportSchema,
  });
}

export function getDemoQrGallery(page: number, pageSize: number): Promise<DemoQrGalleryResponse> {
  const params = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
  return apiFetch<DemoQrGalleryResponse>(`/api/demo/qr-gallery?${params.toString()}`, {
    schema: DemoQrGalleryResponseSchema,
  });
}
